import {translations} from 'presentation/translations-new';
import {StepPreviewEnum, StepPreviewEnumV2} from '../../pages/RequestPreview/types';

const {stepsTitle} = translations['pt-br'].privateFlow.previewRefund;

export const TITLE_BY_STEP = {
	[StepPreviewEnum.BENEFICIARY_DATA]: stepsTitle.beneficiaryData,
	[StepPreviewEnum.SERVICE_TYPE]: stepsTitle.service,
	[StepPreviewEnum.UPLOAD_DOCUMENTS]: stepsTitle.uploadDocuments,
	[StepPreviewEnum.REVIEW]: stepsTitle.review,
};

export const TITLE_BY_STEP_V2: Record<number, string> = {
	[StepPreviewEnumV2.BENEFICIARY_DATA]: stepsTitle.beneficiaryData,
	[StepPreviewEnumV2.SERVICE_TYPE]: stepsTitle.serviceV2,
	[StepPreviewEnumV2.PROCEDURES]: stepsTitle.procedure,
	[StepPreviewEnumV2.RESULT]: stepsTitle.result,
};
